import React from 'react';

function Products() {
    return (
        <section className="relative">

        </section>
    );
}

export default Products;